import React from 'react'
import { CuiButton } from 'front-lib'
import MetaTags from '../MetaTags'
import HeroCui from '../HeroCui'
import Background from '../../assets/img/resurrectionHeroNew.jpg'

const DishBannerResurrection = ({
  restartAction,
  text,
  browserTitle,
  heroTitle,
  heroSubtitle,
  heroImageUrl
}: {
  restartAction: () => void
  text: string | undefined
  browserTitle: string | undefined
  heroTitle: string | undefined
  heroSubtitle: string | undefined
  heroImageUrl: string | undefined
}) => {
  return (
    <div style={{ width: '100%' }}>
      <MetaTags
        image={Background}
        canonical={window.location.href}
        title={
          browserTitle && browserTitle.length > 0
            ? browserTitle
            : heroTitle
            ? `${heroTitle} | CookUnity`
            : `Let's Start fresh.`
        }
        description={text}
      />
      <HeroCui
        image={heroImageUrl ?? Background}
        className="resurrectionHero"
        style={{}}>
        <h1 className="rebrand">
          {heroTitle ?? (
            <>
              Let's start <span>fresh</span>
            </>
          )}
        </h1>
        <p className="rebrand">
          {heroSubtitle && heroSubtitle.length > 0 ? (
            heroSubtitle
          ) : (
            <>
              Come back and enjoy more meals, more chefs,
              <br /> more deliciousness!
            </>
          )}
        </p>
        <h2 className="rebrand">{text}</h2>
        <CuiButton onClick={restartAction} size="large">
          Resubscribe Now
        </CuiButton>
      </HeroCui>
    </div>
  )
}

export default DishBannerResurrection
